export default __webpack_public_path__ + "static/media/logo-alkor-white.c547b92f.png";